exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-updates-jsx": () => import("./../../../src/pages/updates.jsx" /* webpackChunkName: "component---src-pages-updates-jsx" */),
  "component---src-templates-blog-template-js": () => import("./../../../src/templates/blog_template.js" /* webpackChunkName: "component---src-templates-blog-template-js" */)
}

